export const RE_DIGIT = new RegExp(/^\d+$/);
export const STRONG_PASSWORD_REGEX = new RegExp(
  /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/
);
export const EMAIL_REGEX = new RegExp(
  /^(([_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]([\w\-])+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,6})))+$/
);
export const PHONE_NUMBER_INDIA_REGEX = new RegExp(/^\+91\s\d{5}-\d{5}$/);
export const PHONE_NUMBER_SINGAPORE_REGEX = new RegExp(/^\+65\s\d{4}-\d{4}$/);
